/**
 * Identity Platform API helper. Uses fetch with response.clone() pattern to
 * avoid "body stream already read" errors that occur when Emergent's reverse
 * proxy injects fetch wrappers (matches Vault tool's working pattern).
 *
 * Internal Truckwash-ops API calls keep using axios (see lib/apiClient or
 * direct axios — token automatically attached via global interceptor in index.js).
 */
import { getAccessToken, getRefreshToken, setTokens } from './tokenStore';

export const IDENTITY_URL = (process.env.REACT_APP_IDENTITY_PLATFORM_URL || 'https://id.truckwash1.cloud').replace(/\/+$/, '');
export const TOOL_ID = process.env.REACT_APP_TOOL_ID || 'truckwash-ops';

const safeJson = async (res) => {
  // Clone-pattern: body might be locked by upstream wrappers
  try {
    return await res.clone().json();
  } catch {
    try {
      return await res.json();
    } catch {
      return null;
    }
  }
};

export const identityValidate = async (token) => {
  try {
    const res = await fetch(`${IDENTITY_URL}/api/validate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, tool_id: TOOL_ID }),
    });
    return await safeJson(res);
  } catch {
    return null;
  }
};

export const identityRefresh = async () => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) return false;
  try {
    const res = await fetch(`${IDENTITY_URL}/api/auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
    if (!res.ok) return false;
    const data = await safeJson(res);
    if (data?.access_token) {
      setTokens(data.access_token, data.refresh_token || refreshToken);
      return true;
    }
    return false;
  } catch {
    return false;
  }
};

export const identityFetchUserRights = async () => {
  const token = getAccessToken();
  if (!token) return null;
  try {
    const res = await fetch(
      `${IDENTITY_URL}/api/user-rechten/${TOOL_ID}?include_rol=true`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (!res.ok) return null;
    return await safeJson(res);
  } catch {
    return null;
  }
};

export const redirectToLogin = () => {
  const callback = `${window.location.origin}/auth/callback`;
  window.location.href = `${IDENTITY_URL}/login?redirect=${encodeURIComponent(callback)}`;
};
